import { render } from "./KpiDetailModal.vue?vue&type=template&id=23559c48&scoped=true"
import script from "./KpiDetailModal.vue?vue&type=script&lang=js"
export * from "./KpiDetailModal.vue?vue&type=script&lang=js"

import "./KpiDetailModal.vue?vue&type=style&index=0&id=23559c48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23559c48"]])

export default __exports__